'use strict';

const materialIcon = require('../materialIcon');
const initPopOver = require('../components/initPopOver');
const { getTranslation } = require('../common/jsTranslations');
const { getConfig } = require('../common/jsConfig');
const { showToastMessage } = require('../../js/components/toast');

/**
 * appends params to a url
 * @param {string} url - Original url
 * @param {Object} params - Parameters to append
 * @returns {string} result url with appended parameters
 */
function appendToUrl(url, params) {
    var newUrl = url;
    newUrl += (newUrl.indexOf('?') !== -1 ? '&' : '?') + Object.keys(params).map(function (key) {
        return key + '=' + encodeURIComponent(params[key]);
    }).join('&');

    return newUrl;
}

/**
 * re-renders the order totals and the number of items in the cart
 * @param {Object} data - AJAX response from the server
 */
function updateCartTotals(data) {
    $('.number-of-items').empty().append(data.resources.numberOfItems);
    $('.shipping-cost').empty().append(data.totals.totalShippingCost);
    $('.tax-total').empty().append(data.totals.totalTax);
    $('.grand-total').empty().append(data.totals.grandTotal);
    $('.sub-total').empty().append(data.totals.subTotal);
    $('.minicart-quantity').empty().append(data.numItems);
    $('.minicart-link').attr({
        'aria-label': data.resources.minicartCountOfItems,
        title: data.resources.minicartCountOfItems
    });
    if (data.totals.orderLevelDiscountTotal.value > 0) {
        $('.order-discount').removeClass('hide-order-discount');
        $('.order-discount-total').empty()
            .append('- ' + data.totals.orderLevelDiscountTotal.formatted);
        $('.js-order-discount-label').text(data.totals.orderDiscountLabel);
    } else {
        $('.order-discount').addClass('hide-order-discount');
    }

    if (data.totals.shippingLevelDiscountTotal.value > 0) {
        $('.shipping-discount').removeClass('hide-shipping-discount');
        $('.shipping-discount-total').empty().append('- '
            + data.totals.shippingLevelDiscountTotal.formatted);
    } else {
        $('.shipping-discount').addClass('hide-shipping-discount');
    }

    var hasDiscounts = data.totals.orderLevelDiscountTotal.value > 0 || data.totals.shippingLevelDiscountTotal.value > 0;
    $('.js-discounts-header').toggleClass('d-none', !hasDiscounts);

    data.items.forEach(function (item) {
        if (data.totals.orderLevelDiscountTotal.value > 0) {
            $('.coupons-and-promos').empty().append(data.totals.discountsHtml);
        }
        if (item.renderedPromotions) {
            $('.item-' + item.UUID).empty().append(item.renderedPromotions);
        } else {
            $('.item-' + item.UUID).empty();
        }

        let unitPrice = item.renderedPrice;

        if (item.renderedConfiguratorPrice) {
            unitPrice = item.renderedConfiguratorPrice;
            $('.line-item-header > a').attr('href', item.url);
        }

        $('.uuid-' + item.UUID + ' .unit-price').empty().append(unitPrice);
        $('.line-item-price-' + item.UUID + ' .unit-price').empty().append(unitPrice);
        $('.item-total-' + item.UUID).empty().append(item.priceTotal.renderedPrice);
    });

    if (data.totals.klarnaTotal) {
        $('klarna-placement').attr('data-purchase-amount', data.totals.klarnaTotal);
        if (window.Klarna && window.Klarna.OnsiteMessaging) {
            window.Klarna.OnsiteMessaging.refresh();
        }
    }
}

/**
 * re-renders the order totals and the number of items in the cart
 * @param {Object} message - Error message to display
 */
function createErrorNotification(message) {
    showToastMessage({
        message: message,
        alertType: 'alert-danger',
        disableAutoClosing: true
    });
}

/**
 * re-renders the approaching discount messages
 * @param {Object} approachingDiscounts - updated approaching discounts for the cart
 */
function updateApproachingDiscounts(approachingDiscounts) {
    const cartIcon = `<span class="svg-wrapper-success material-icon-wrapper-x-small lh-1">${materialIcon.shopping_cart}</span>`;
    const html = approachingDiscounts.map(function (item) {
        const modalTrigger = item.hasModal
            ? ` <button type="button" class="btn-reset p-0 text-inherit text-decoration-underline" data-bs-toggle="modal" data-bs-target="#modal-${item.promotionID}">${item.moreDetailsLabel}</button>`
            : '';
        const headline = `<p class="fw-bold mb-3 d-flex align-items-center gap-1">${cartIcon}${item.headlineMsg}</p>`;
        const body = item.isQualified
            ? `<p class="mb-0 small">${item.appliedMsg}${modalTrigger}</p>`
            : `<p class="mb-1 small">${item.addMoreMsg}${modalTrigger}</p>
               <div class="progress approaching-discount-progress mb-1" role="progressbar"
                   aria-valuenow="${item.progressPercent}"
                   aria-valuemin="0"
                   aria-valuemax="100">
                   <div class="progress-bar bg-success" style="width: ${item.progressPercent}%"></div>
               </div>
               <div class="d-flex gap-6 justify-content-between">
                   <span class="x-small text-truncate">${item.inCartMsg}</span>
                   <span class="x-small text-truncate">${item.neededMsg}</span>
               </div>`;
        return `<div class="single-approaching-discount border border-success-100 rounded py-2 px-3 mb-6 text-success">${headline}${body}</div>`;
    }).join('');
    $('.approaching-discounts').empty().append(html);
}

/**
 * Updates the availability of a product line item
 * @param {Object} data - AJAX response from the server
 * @param {string} uuid - The uuid of the product line item to update
 */
function updateAvailability(data, uuid) {
    var lineItem;
    var messages = '';
    const showAvailabilityHelpText = getConfig('showAvailabilityHelpText');

    for (var i = 0; i < data.items.length; i++) {
        if (data.items[i].UUID === uuid) {
            lineItem = data.items[i];
            break;
        }
    }

    if (lineItem != null) {
        $('.availability-' + lineItem.UUID).empty();
        const availabilityHelpTextButton = (message) => {
            const helpText = lineItem?.availability?.helpText[0];
            return helpText ? `
                <button
                    class="btn-reset text-inherit p-0 lh-1"
                    title="${message}"
                    data-bs-toggle="popover"
                    data-bs-trigger="hover focus"
                    data-bs-placement="auto"
                    data-bs-html="true"
                    data-bs-container="body"
                    data-bs-content="${helpText}">
                    <span class="svg-wrapper-inherit material-icon-wrapper-x-small">
                        ${materialIcon.info}
                    </span>
                </button>
            ` : '';
        };

        if (lineItem.availability) {
            if (lineItem.availability.messages) {
                lineItem.availability.messages.forEach((message, index) => {
                    const status = lineItem.availability.status[index];
                    messages += `<span class="product-availability-message availability-msg product-availability-message-${status} mw-100">
                                    <span class="text-truncate">${message}</span>${showAvailabilityHelpText ? availabilityHelpTextButton(message) : ''}
                                </span>`;
                });
            }

            if (lineItem.availability.inStockDate) {
                messages += `<span class="line-item-attributes line-item-instock-date text-body-secondary text-nowrap">
                               ${getTranslation('helpText.availability.eta').replace('{0}', lineItem.availability.inStockDate)}
                            </span>`;
            }
            if (data.isPreOrder) {
                $('.js-preorder-warning-message')?.removeClass('d-none');
            } else {
                $('.js-preorder-warning-message')?.addClass('d-none');
            }
        }

        $('.availability-' + lineItem.UUID).html(messages);
        initPopOver();
    }
}

/**
 * Checks whether the basket is valid. if invalid displays error message and disables
 * checkout button
 * @param {Object} data - AJAX response from the server
 */
function validateBasket(data) {
    var checkoutDisabled = Boolean(data.valid.error || data.checkoutBlocked);

    if (data.valid.error) {
        if (data.valid.message) {
            showToastMessage({
                message: data.valid.message,
                alertType: 'alert-danger',
                disableAutoClosing: true
            });
        } else {
            $('.cart').empty().append('<div class="card"> '
                + '<div class="card-body text-center py-9"> '
                + '<h1 class="mb-5">' + data.resources.emptyCartMsg + '</h1> '
                + '</div>'
                + '</div>');
            $('.number-of-items').empty().append(data.resources.numberOfItems);
            $('.minicart-quantity').empty().append(data.numItems);
            $('.minicart-link').attr({
                'aria-label': data.resources.minicartCountOfItems,
                title: data.resources.minicartCountOfItems
            });
            $('.minicart .popover').empty();
            $('.minicart .popover').removeClass('show');
        }
    }

    var $checkoutButton = $('.checkout-btn');
    $checkoutButton
        .toggleClass('disabled', checkoutDisabled)
        .attr('aria-disabled', checkoutDisabled)
        .attr('tabindex', checkoutDisabled ? '-1' : null);

    if (checkoutDisabled) {
        $checkoutButton.removeAttr('href');
    } else {
        $checkoutButton.attr('href', $checkoutButton.data('checkout-url'));
    }

    $('.js-checkout-blocked-error').toggleClass('d-none', !data.checkoutBlocked);
}

/**
 * replace content of modal
 * @param {string} actionUrl - url to be used to remove product
 * @param {string} productID - pid
 * @param {string} productName - product name
 * @param {string} uuid - uuid
 * @param {number} qty - qty
 */
function confirmDelete(actionUrl, productID, productName, uuid, qty) {
    var $deleteConfirmBtn = $('.cart-delete-confirmation-btn');
    var $productToRemoveSpan = $('.product-to-remove');

    $deleteConfirmBtn.data('pid', productID);
    $deleteConfirmBtn.data('action', actionUrl);
    $deleteConfirmBtn.data('uuid', uuid);
    $deleteConfirmBtn.data('qty', qty);

    $productToRemoveSpan.empty().append(productName);
}

/**
 * Updates the express payment methods based on the provided data.
 *
 * @param {Object} data - The data containing the express checkout information.
 * @param {boolean} data.expressCheckoutDisabled - Indicates whether express checkout is disabled.
 * @param {string} data.renderedAmazonExpressButton - The rendered amazon express button.
 * @param {string} data.renderedKlarnaExpressButton - The rendered klarna express button.
 * @return {void} This function does not return anything.
 */
function updateExpressPaymentMethods(data) {
    var $expressSeparator = $('.checkout-continue').find('.line-through');
    var $expressPaymentMethods = $('.js-express-payment-methods');
    var checkoutBlocked = Boolean(data.checkoutBlocked);

    $expressPaymentMethods
        .toggleClass('disabled-wrapper', checkoutBlocked)
        .prop('inert', checkoutBlocked);

    if (!data.expressCheckoutDisabled) {
        $('.amazon-express-button')?.html(data.renderedAmazonExpressButton);
        $('.kec-cart')?.html(data.renderedKlarnaExpressButton);
        if ($('.kec-cart').length) {
            window.klarnaAsyncCallback?.();
        }
        $('.js-kosm-cart')?.html(data.renderedKOSMCart);
    } else {
        $('.amazon-express-button')?.html('');
        $('.kec-cart')?.html('');
        $('.js-kosm-cart')?.html('');
    }

    if ($expressSeparator.length) {
        $expressSeparator.toggleClass('d-none', data.expressCheckoutDisabled);
    }
}

/**
 * Toggles visibility of elements based on the state of the shopping basket and product conditions.
 * Elements are shown or hidden by switching between Bootstrap classes `d-none` and `d-block`.
 * @param {Object} data - Object containing basket and product properties.
 */
function updateCountdownVisibility(data) {
    const countdownWrapper = $('.js-countdown-wrapper');

    $(countdownWrapper).each(function () {
        const shouldShowElement = data.basket.valid && !data.basket.valid.error && !data.hasConfiguratorProduct && !data.hasPreOrder;

        if (shouldShowElement) {
            $(this).removeClass('d-none').addClass('d-block');
        } else {
            $(this).removeClass('d-block').addClass('d-none');
        }
    });
}

module.exports = {
    appendToUrl: appendToUrl,
    updateCartTotals: updateCartTotals,
    createErrorNotification: createErrorNotification,
    updateApproachingDiscounts: updateApproachingDiscounts,
    updateAvailability: updateAvailability,
    validateBasket: validateBasket,
    confirmDelete: confirmDelete,
    updateExpressPaymentMethods: updateExpressPaymentMethods,
    updateCountdownVisibility: updateCountdownVisibility
};
